import { talentApi as gwnlApi, ulcdApi, o2oApi, apiBaseUrl} from 'yxt-biz-pc/packages/api';
// 模型下职责任务列表
export const getDutyFromModel = (modelId) => {
  return gwnlApi.get(`mgr/model/rtmodel/rtmap/${modelId}`);
};

// 模型下职责任务列表
export const getDutyFromProject = (porjectId, params) => {
  return apiBaseUrl.get(`sptalent/mgr/model/rtmodel/rtmap/multi/${porjectId}`, params);
};

export const getSkillsByTemplateId = (id, data, params, talent = true) => {
  return apiBaseUrl.post(`${talent ? 'talent' : 'sptalent'}/mgr/model/skillmodel/${id}`, data, { params: params });
};

export const getSkillsByProjectId = (id, data, params) => {
  return apiBaseUrl.post(`sptalent/mgr/model/skillmodel/multi/${id}`, data, { params: params });
};

// 任职资格详情-不包括能力分类
export const getJqDetailByProjectId = (projectId) => {
  return gwnlApi.get(`mgr/designer/related/termsInfo/${projectId}`);
};

// 查询大纲中考核任务已经关联的职责任务信息
export const getRelatedTasksByProjectId = (projectId) => ulcdApi.get(`biz/arranges/${projectId}/rtTask`);
;

// 获取项目培训模型
export const getProjectModel = (projectId) => {
  return o2oApi.get(`project/skillmodel/${projectId}/info`);
};
